import { Button } from "@9amhealth/shared";
import { NineHeading } from "@9amhealth/wcl/generated/react";
import { useBlocNext } from "@blac/react";
import React from "react";
import { AddPharmacyInsuranceDocuments } from "src/state/PatientPharmacyInsuranceBloc/PatientPharmacyInsuranceBloc";
import DocumentUploader from "src/ui/components/DocumentUploader/DocumentUploader";
import Translate from "src/ui/components/Translate/Translate";
import MedicalInsuranceFormBloc from "./MedicalInsuranceFormBloc";
import styled from "@emotion/styled";
import { APP_CONTENT_WIDTH } from "src/constants/layout";
import translate from "src/lib/translate";
import FileType from "src/constants/fileType";

const Wrap = styled.div`
  max-width: ${APP_CONTENT_WIDTH}px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  margin-top: 2rem;
`;

const MedicalInsuranceUploadPhoto = () => {
  const [
    { allImagesSelected, photoUploadCanBeSkippedByUser },
    { handleFileUploadCardPhotoChange, handleSaveCardPhotos, cardPhotoFileIds }
  ] = useBlocNext(MedicalInsuranceFormBloc, { id: "medical-insurance-form" });

  return (
    <section>
      <NineHeading>
        <h3 className="as-h4-large">
          <Translate msg="insurance.uploadPhoto" />
        </h3>
        <p>
          <Translate msg="insurance.uploadPhoto.description" />
        </p>
      </NineHeading>

      <nine-spacer s="lg"></nine-spacer>

      <Wrap>
        <DocumentUploader
          config={{
            fileTypes: ["image/jpeg", "image/png"],
            files: {
              [AddPharmacyInsuranceDocuments.FRONT]: {
                initialFileId: cardPhotoFileIds?.frontPhotoFileId,
                title: translate("update.frontSide"),
                tags: ["medical-insurance-card-front"],
                namePrefix: "Medical Insurance Card Front",
                metaFileType: FileType.MEDICAL_INSURANCE_CARD
              },
              [AddPharmacyInsuranceDocuments.BACK]: {
                initialFileId: cardPhotoFileIds?.backPhotoFileId,
                title: translate("update.backSide"),
                tags: ["medical-insurance-card-back"],
                namePrefix: "Medical Insurance Card Back",
                metaFileType: FileType.MEDICAL_INSURANCE_CARD
              }
            }
          }}
          onChange={handleFileUploadCardPhotoChange}
        />

        <ButtonContainer>
          <Button
            onPress={handleSaveCardPhotos}
            isDisabled={!allImagesSelected}
          >
            <Translate msg="continue" />
          </Button>

          {photoUploadCanBeSkippedByUser && (
            <Button theme="transparent" onPress={handleSaveCardPhotos}>
              <Translate msg="insurance.skipPhotoUpload" />
            </Button>
          )}
        </ButtonContainer>
      </Wrap>
    </section>
  );
};

export default MedicalInsuranceUploadPhoto;
